<script>
import { 
    layoutComponents,
    assistComponents,
    selectComponents,
    systemComponents,
    personalInfoComponents,
    tasktComponents,
    formConf 
} from './utils/leftBoard'
import draggable from "vuedraggable"
import DraggableItem from "./render/DraggableItem.vue"
import Right from "./render/right.vue"
// 表单渲染组件
import Vue from 'vue'
import elDynamicForm from 'el-dynamic-form'
Vue.use(elDynamicForm)
import { copy, EventHub } from './utils/tools'
const left = {
    name: 'left',
    props: {
        cloneComponent: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            leftComponents: [
                // {
                //     title: '布局型组件',
                //     components: layoutComponents,
                // },
                {
                    title: "辅助型组件",
                    components: assistComponents,
                },
                {
                    title: "进阶型组件",
                    components: selectComponents,
                },
                {
                    title: "系统组件",
                    components: systemComponents,
                },
                {
                    title: "扩展型组件",
                    components: personalInfoComponents,
                },
                {
                    title: "业务型组件",
                    components: tasktComponents,
                },
            ],
        }
    },
    render() {
        const { leftComponents } = this
        return (
            <div class="left-board">     
                <div class="components-list">
                    {
                        leftComponents.map((item, index) => {
                            return (
                                <Fragment>
                                    <div class="components-title" key={index}>{item.title}</div>
                                    <draggable
                                        clone={this.cloneComponent}
                                        group={{
                                            name: 'componentsGroup',
                                            pull: 'clone',
                                            put: false
                                        }}
                                        list={item.components}
                                        sort={false}
                                        class="components-draggable"
                                        animation="300"
                                        draggable=".components-item" 
                                    >
                                        <transition-group>
                                            {
                                                item.components.map((element, index) => {
                                                    return (
                                                        <div key={index} class="components-item" onClick={() => this.$emit('componentClick', element)}>
                                                            <div class="components-body">{ element.__config__.label }</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </transition-group>
                                    </draggable>
                                </Fragment>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}
const PreviewDialog = {
    name: 'PreviewDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        formItems: {
            type: Array,
            default: () => []
        },
        formRules: {
            type: Array,
            default: () => []
        },
        formName: {
            type: String,
            default: ''
        }
    },
    render() {
        return (
            <el-dialog 
                title="预览"
                width="60%" 
                visible={this.value}
                beforeClose={() => this.$emit('input', false) }
                close-on-click-modal
            >
                <h3 style="text-align: center">{this.formName}</h3>
                {
                    this.value ?  (
                        <el-dynamic-form
                            ref="elDynamicForm"
                            class="elDynamicForm"
                            formConfig={this.formItems}
                            formRules={this.formRules}
                            readonly={true}
                            option={this.$attrs.option}
                            formData={{}}
                        />
                    ) : null
                }
                <template slot="footer">
                    <span>
                        <el-button onClick={() => this.$emit('input', false) }>取 消</el-button>
                    </span>
                </template>
            </el-dialog>
        )
    }
}
export default {
    name: 'el-dynamic-form-design',
    props: {
        value: Object,
    },
    data() {
        const form = {
            formConf,
            selectFormItem: null,
            design: {
                formItems: [],
                id: undefined,
                formName: '表单名称',
                childs: [],
            },
            cacheDesign: null,
            rules: []
        }
        const { rules, formName, formItems } = this.value
        if(rules) form.rules = rules
        if(formName) form.design.formName = formName
        if(formItems && formItems.length) {
            form.design.formItems = formItems
            if(form.selectFormItem === null) {
                form.selectFormItem = formItems[0] 
            }
        }
        return {
            form,
            showPreviewDialog: false,
        }
    },
    components: {
        draggable,
        DraggableItem,
        Right
    },
    watch: {
        form: {
            handler(value) {
                const data = {
                    rules: value.rules,
                    formItems: value.design.formItems,
                    formName: value.design.formName
                }
                console.log(data, 123)
                this.$emit('input', data)
                this.$emit('selectItem', value.selectFormItem)
            },
            deep: true
        }
    },
    render() {
        const { design: {formItems, formName, childs} } = this.form
        const empty = () => {
            this.form.design.formItems = formItems.filter(item => item.typeId === "INFO_FEEDBACK")
            this.form.design.childs = []
        }
        const createIdAndKey = item => {
            const config = item.__config__
            const cacheId = +new Date()
            config.formId = cacheId
            config.renderKey = `${config.formId}${+new Date()}`; // 改变renderKey后可以实现强制更新组件
            if (this.cacheDesign && this.cacheDesign.config.__vModel__.includes("infoFeedback")) {
                item.__vModel__ = `infoFeedback${cacheId}`
            } else {
                item.__vModel__ = `field${cacheId}`
            }
            if (config.layout === "rowFormItem") {
                config.componentName = `行${cacheId}`;
                !Array.isArray(config.children) && (config.children = [])
                delete config.label; // rowFormItem无需配置label属性
            }
            if (Array.isArray(config.children)) {
                config.children = config.children.map((childItem) =>
                this.createIdAndKey(childItem)
                )
            }
            return item
        }
        const resetFormRules = () => {
            // 清除表单显隐规则
            if(this.form.rules.length) {
                this.$notify({
                    title: "温馨提示",
                    message: "变动表单后已将设置表单规则重置！",
                })
                this.form.rules = []
            }
        }
        const addComponent = item => {
            const clone = cloneComponent(item)
            this.form.design.formItems.push(clone)
        }
        const cloneComponent = item => {
            const clone = copy(item)
            const config = clone.__config__
            config.variable = config.variable || ""
            config.span = this.form.formConf.span
            createIdAndKey(clone)
            this.form.selectFormItem = clone
            return clone
        }
        const checkMove = () => {
            resetFormRules()
            return true
        }
        // 预览表单
        const preview = () => this.showPreviewDialog = true
        return (
            <div class="wrap">
                <left cloneComponent={cloneComponent} onComponentClick={item => addComponent(item)}/>
                {/* 中间表单部分开始 */}
                <div class="center-board">
                    <div class="btn-action">
                        <el-button type="danger" size="mini" round 
                            onClick={() => {
                                this.$confirm("确定要清空所有组件吗？", "提示", { type: "warning" }).then(() => {
                                    empty()
                                }).catch(() => {})
                            }}
                        >清空</el-button>
                        <el-button type="primary" size="mini" round onClick={() => preview()}>预览</el-button>
                    </div>
                    <el-scrollbar class="center-scrollbar">
                        <el-row class="center-board-row">
                            <el-row align="middle" justify="center" type="flex">
                                <el-col class="form-head-title">
                                    <h4 class="form-name-text" contenteditable="true"  
                                        onBlur={event => this.form.design.formName = event.target.innerText }
                                    >{ formName }</h4>
                                </el-col>
                            </el-row>
                            <el-divider class="form-head-divider" />
                            <el-form size="mini">
                                <draggable animation={340} list={formItems} class="drawing-board" group="componentsGroup" move={() => checkMove()}>
                                    {
                                        formItems.map((item, index) => {
                                            return (
                                                <draggable-item 
                                                    key={index} 
                                                    currentItem={item}
                                                    drawingList={formItems}  
                                                    index={index}
                                                    selectItem={this.form.selectFormItem}
                                                    onActiveItem={ currentItem => this.form.selectFormItem = currentItem }
                                                    onCopyItem={ (item, list) => {
                                                        let clone = copy(item)
                                                        clone = createIdAndKey(clone)
                                                        list.push(clone)
                                                        this.form.selectFormItem = clone
                                                    } }
                                                    onDeleteItem={ (index, list) => {
                                                        list.splice(index, 1)
                                                        this.$nextTick(() => {
                                                            const length = formItems.length
                                                            if( length ) {
                                                                this.form.selectFormItem = formItems[length - 1]
                                                            }
                                                        })
                                                        resetFormRules()
                                                    } }
                                                    onCreatClick={ (config, index) => {
                                                        console.log(config, 123)
                                                    } }
                                                    attrs={{...this.$attrs, eventHub: new EventHub()}}
                                                />
                                            )
                                        })
                                    }
                                </draggable>
                            </el-form>
                            {
                                formItems.length ? null : (
                                    <div class="empty-info">
                                        <el-empty description="从左侧拖入或点选组件进行模板设计"></el-empty>
                                    </div>
                                )
                            }
                        </el-row>
                    </el-scrollbar>
                </div>
                {/* 中间表单部分结束 */}
                {/* 右边表单配置 */}
                <Right form={this.form}  onSetRules={rules => this.form.rules = rules} selectItem={this.form.selectFormItem} attrs={this.$attrs} />
                {/* 表单预览 */}
                <PreviewDialog 
                    v-model={this.showPreviewDialog} 
                    formName={this.form.design.formName} 
                    formItems={this.form.design.formItems} 
                    formRules={this.form.rules} 
                    attrs={this.$attrs} 
                />
            </div>
        )
    }
}
</script>
<style lang="scss">
@import "@/assets/style/index";
.wrap{
    display: flex;
    height: 100%;
    overflow: hidden;
}
.center-board {
  .center-board-row {
    margin-right: 10px;
  }
  .btn-action {
    display: flex;
    justify-content: end;
  }

  .form-head-title {
    padding: 0 10px;
    text-align: center;

    .form-name-text:hover {
      border: 1px dashed #7b7b7b;
      min-height: 100px;
    }
  }

  .form-head-desc {
    padding: 0 10px;
  }

  .form-head-divider {
    margin-right: 10px;
    margin-left: 10px;
    width: auto;
  }
}
</style>